/*
 * This minor headache is what allows us to use the minimal set of FA icons without bringing in
 * huge files.  We explicitly import the icons we need here, and `dom.watch` replaces them on
 * page with their SVG equivalents. */
import { dom, library } from "@fortawesome/fontawesome-svg-core";

import {
  faAngleDown,
  faAngleRight,
  faArrowDown,
  faArrowLeft,
  faArrowUpRightFromSquare,
  faArrowRight,
  faArrowUp,
  faArrowRotateRight,
  faAsterisk,
  faAtom,
  faBalanceScale,
  faBars,
  faBoxArchive as faBoxArchiveSolid,
  faBoxes,
  faBug,
  faCaretDown,
  faCaretUp,
  faCheck,
  faCheckCircle,
  faCheckDouble,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircleNotch,
  faClock,
  faClockRotateLeft,
  faCloudArrowUp,
  faCode,
  faCogs,
  faComment,
  faCopy,
  faDollarSign,
  faDownload,
  faEdit,
  faEllipsis,
  faEllipsisV,
  faEnvelope,
  faEquals,
  faEuroSign,
  faExclamationTriangle,
  faExternalLinkAlt,
  faEye,
  faFileAlt,
  faFileImage,
  faFileImport,
  faFileInvoice,
  faFilePdf,
  faFileWord,
  faFileExcel,
  faFilm,
  faFilter,
  faFlask,
  faGear,
  faGift,
  faInbox,
  faInfoCircle,
  faLock,
  faMinus,
  faMinusSquare,
  faNoteSticky,
  faNotEqual,
  faBolt,
  faPaintRoller,
  faPalette,
  faPaperclip,
  faPen,
  faPenToSquare,
  faPhoneAlt,
  faPlay,
  faPlus,
  faPlusCircle,
  faPrint as faPrintSolid,
  faQuestionCircle,
  faQuoteLeft,
  faRedo,
  faRetweet,
  faRightLeft,
  faRotateLeft,
  faSearch,
  faSearchPlus,
  faServer,
  faShieldHalved,
  faSpinner,
  faSterlingSign,
  faSync,
  faSyncAlt,
  faTable,
  faTags,
  faTasks,
  faTimes,
  faTimesCircle,
  faTrash,
  faTrashAlt,
  faUndo,
  faUpload,
  faUpRightAndDownLeftFromCenter,
  faUser,
  faUsers as faUsersSolid,
  faUtensils,
  faObjectGroup,
} from "@fortawesome/free-solid-svg-icons";

library.add(
  faAngleDown,
  faAngleRight,
  faArrowDown,
  faArrowLeft,
  faArrowUpRightFromSquare,
  faArrowRight,
  faArrowRotateRight,
  faArrowUp,
  faAsterisk,
  faBalanceScale,
  faBars,
  faBoxArchiveSolid,
  faBoxes,
  faBug,
  faCaretDown,
  faCaretUp,
  faCheck,
  faCheckCircle,
  faCheckDouble,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircleNotch,
  faClock,
  faClockRotateLeft,
  faCloudArrowUp,
  faCode,
  faCogs,
  faComment,
  faCopy,
  faDollarSign,
  faDownload,
  faEdit,
  faEllipsis,
  faEllipsisV,
  faEnvelope,
  faEquals,
  faEuroSign,
  faExclamationTriangle,
  faExternalLinkAlt,
  faEye,
  faFileAlt,
  faFileImage,
  faFileImport,
  faFileInvoice,
  faFilePdf,
  faFileWord,
  faFileExcel,
  faFilm,
  faFilter,
  faFlask,
  faGear,
  faGift,
  faInbox,
  faInfoCircle,
  faLock,
  faMinus,
  faMinusSquare,
  faNoteSticky,
  faNotEqual,
  faBolt,
  faPaintRoller,
  faPalette,
  faPaperclip,
  faPen,
  faPenToSquare,
  faPhoneAlt,
  faPlay,
  faPlus,
  faPlusCircle,
  faPrintSolid,
  faQuestionCircle,
  faQuoteLeft,
  faRedo,
  faRetweet,
  faRightLeft,
  faRotateLeft,
  faSearch,
  faSearchPlus,
  faServer,
  faShieldHalved,
  faSpinner,
  faSterlingSign,
  faSync,
  faSyncAlt,
  faTable,
  faTags,
  faTasks,
  faTimes,
  faTimesCircle,
  faTrash,
  faTrashAlt,
  faUndo,
  faUpload,
  faUpRightAndDownLeftFromCenter,
  faUser,
  faUsersSolid,
  faUtensils,
  faObjectGroup,
  faAtom
);

import {
  faBadgeCheck,
  faBottleWater,
  faBrain,
  faCalculator,
  faCapsules,
  faChartPie,
  faCheckCircle as faCheckCircleDuotone,
  faCode as faCodeDuotone,
  faCommentsQuestionCheck as faCommentsQuestionCheckDuotone,
  faCogs as faCogsDuotone,
  faCubes as faCubesDuotone,
  faDatabase,
  faDna,
  faExclamationTriangle as faExclamationTriangleDuotone,
  faFilm as faFilmDuotone,
  faFilter as faFilterDuotone,
  faFilters,
  faGears,
  faGrid2,
  faIceCream,
  faLaptopMobile,
  faList,
  faListUl,
  faLock as faLockDuotone,
  faPeanuts as faPeanutsDuotone,
  faPepperHot,
  faPopcorn,
  faPrint,
  faRectangleList,
  faRectanglesMixed,
  faRobot as faRobotDuotone,
  faShop,
  faSlidersH as faSlidersHDuotone,
  faSparkles,
  faTruckFast,
  faUser as faUserDuotone,
  faUsers,
} from "@fortawesome/pro-duotone-svg-icons";

library.add(
  faBadgeCheck,
  faBottleWater,
  faBrain,
  faCalculator,
  faCapsules,
  faChartPie,
  faCheckCircleDuotone,
  faCodeDuotone,
  faCommentsQuestionCheckDuotone,
  faCogsDuotone,
  faCubesDuotone,
  faDatabase,
  faDna,
  faExclamationTriangleDuotone,
  faFilmDuotone,
  faFilterDuotone,
  faFilters,
  faGears,
  faGrid2,
  faIceCream,
  faLaptopMobile,
  faList,
  faListUl,
  faLockDuotone,
  faPeanutsDuotone,
  faPepperHot,
  faPopcorn,
  faPrint,
  faRectangleList,
  faRectanglesMixed,
  faRobotDuotone,
  faShop,
  faSlidersHDuotone,
  faSparkles,
  faTruckFast,
  faUserDuotone,
  faUsers
);

import {
  faCube,
  faCubes,
  faDatabase as faDatabaseSharpDuotone,
  faWandMagicSparkles,
} from "@fortawesome/sharp-duotone-solid-svg-icons";
library.add(faCube, faCubes, faDatabaseSharpDuotone, faWandMagicSparkles);

import { faBarcode } from "@fortawesome/sharp-solid-svg-icons";
library.add(faBarcode);

import { faCircleEllipsis } from "@fortawesome/sharp-regular-svg-icons";
library.add(faCircleEllipsis);

import {
  faBoxArchive,
  faCloud,
  faCalendarDays,
  faEyeSlash,
  faInfoCircle as faInfoCircleRegular,
  faLock as faLockRegular,
  faMinusSquare as faMinusSquareRegular,
  faPeanuts,
  faPlusSquare as faPlusSquareRegular,
  faRectangleList as faRectangleListRegular,
  faSparkles as faSparklesRegular,
  faSquare as faSquareRegular,
  faTableTree,
  faTrashUndo,
  faXmark,
} from "@fortawesome/pro-regular-svg-icons";

library.add(
  faBoxArchive,
  faCalendarDays,
  faCloud,
  faEyeSlash,
  faInfoCircleRegular,
  faLockRegular,
  faMinusSquareRegular,
  faPeanuts,
  faPlusSquareRegular,
  faRectangleListRegular,
  faSparklesRegular,
  faSquareRegular,
  faTableTree,
  faTrashUndo,
  faXmark
);

import {
  faArrowProgress,
  faArrowTurnDownRight,
  faSpinnerScale,
  faCircle1,
  faCircle2,
  faCircle3,
  faCircle4,
  faCircle5,
  faCircle6,
  faCircle7,
  faCircle8,
  faCircle9,
  faCircleA,
  faCircleB,
  faCircleC,
  faCircleD,
  faCircleE,
  faCircleF,
  faCircleG,
  faCircleH,
  faCircleI,
  faCircleJ,
  faCircleK,
  faCircleL,
  faCircleM,
  faCircleN,
  faCircleO,
  faCircleP,
  faCircleQ,
  faCircleR,
  faCircleS,
  faCircleT,
  faCircleU,
  faCircleV,
  faCircleW,
  faCircleX,
  faCircleY,
  faCircleZ,
} from "@fortawesome/pro-solid-svg-icons";

library.add(
  faArrowProgress,
  faArrowTurnDownRight,
  faSpinnerScale,
  faCircle1,
  faCircle2,
  faCircle3,
  faCircle4,
  faCircle5,
  faCircle6,
  faCircle7,
  faCircle8,
  faCircle9,
  faCircleA,
  faCircleB,
  faCircleC,
  faCircleD,
  faCircleE,
  faCircleF,
  faCircleG,
  faCircleH,
  faCircleI,
  faCircleJ,
  faCircleK,
  faCircleL,
  faCircleM,
  faCircleN,
  faCircleO,
  faCircleP,
  faCircleQ,
  faCircleR,
  faCircleS,
  faCircleT,
  faCircleU,
  faCircleV,
  faCircleW,
  faCircleX,
  faCircleY,
  faCircleZ
);

import {
  faComment as faCommentLight,
  faCommentsQuestionCheck,
  faSlidersH,
} from "@fortawesome/pro-light-svg-icons";
library.add(faCommentLight, faCommentsQuestionCheck, faSlidersH);

import {
  faArrowAltCircleUp,
  faEye as faEyeRegular,
  faPlayCircle,
} from "@fortawesome/free-regular-svg-icons";

library.add(faArrowAltCircleUp, faEyeRegular, faPlayCircle);

import {
  faTwitter,
  faFacebook,
  faInstagram,
  faCanadianMapleLeaf,
} from "@fortawesome/free-brands-svg-icons";
library.add(faTwitter, faFacebook, faInstagram, faCanadianMapleLeaf);

dom.watch();
